import React from "react";
import { Helmet } from'react-helmet';
import classes from "./homepage.module.css"
import ErrorView from "../../components/ErrorView/errorView";

const Homepage = props => {

    return <>
        <Helmet >
            <title>Cms Page</title>
            <meta name="description" content="beta pages--home page" />
            <link rel="icon" href="https://www.gaxas.ai/api/media/file/favicon-1.svg"/>
        </Helmet>
        <ErrorView />
    </>
}

export default Homepage